import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import { BreakPoint } from 'src/components/shared/CssValues'
import HeadLine from 'src/components/atoms/HeadLine'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'

const CompanyVmv = () => (
  <>
    <BackGround />
    <ContentsWrapper>
      <Content>
        <HeadingBorder heading="VISION / MISSION / VALUE" />
        <HeadLine>経営理念 / 行動指針</HeadLine>

        <VmvContainer css={vmvContainerCss}>
          {vmvContents.map(({ header, description }) => {
            return (
              <React.Fragment key={header + description}>
                <VmvHeader>{header}</VmvHeader>
                <VmvDescription>{description}</VmvDescription>
              </React.Fragment>
            )
          })}
        </VmvContainer>
      </Content>
    </ContentsWrapper>
  </>
)

const Content = styled.div`
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-top: 106px;
    margin-bottom: 100px;
  }
`

const BackGround = styled.div`
  margin-top: -70px;
  width: 100%;
  height: 700px;
  background-color: #eff7fc;
  position: absolute;
  z-index: -1000;
  margin-left: 100px;
  @media screen and (max-width: 1200px) {
    margin-left: 0;
  }
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-top: 10px;
    height: 640px;
  }
`

const VmvContainer = styled.dl`
  font-weight: bold;
  color: #193f51;
`

const vmvContainerCss = css`
  margin: 64px 0 0 22px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin: 20px 0 0 0;
  }
`

const VmvHeader = styled.dt`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;
`

const VmvDescription = styled.dd`
  font-size: 25px;
  line-height: 36px;

  padding-left: 25px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 18px;
    padding-left: 0;
  }

  &:not(:last-child) {
    margin-bottom: 45px;
  }
`

const ValueContainer = styled.dl``

const ValueHeader = styled.dt`
  font-size: 25px;
  margin-bottom: 15px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 18px;
    margin-bottom: 7px;
  }
`

const ValueDescription = styled.dd`
  font-size: 18px;
  line-height: 26px;
  padding-left: 25px;

  &:not(:last-child) {
    margin-bottom: 15px;
  }

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 15px;
  }
`

const vmvContents = [
  { header: 'VISION', description: 'あらゆる組織とひとが融け合う未来をつくる' },
  {
    header: 'VALUE',
    description: (
      <ValueContainer>
        <ValueHeader>超本質主義</ValueHeader>
        <ValueDescription>あるべきにベットし、コトに向かう</ValueDescription>
        <ValueHeader>チームコミューン</ValueHeader>
        <ValueDescription>背中を合わせ、チームで前進する</ValueDescription>
        <ValueHeader>インテグリティ</ValueHeader>
        <ValueDescription>顧客、社会、自分に誠実な仕事をする</ValueDescription>
      </ValueContainer>
    )
  }
]

export default CompanyVmv
